import * as qs from './query-string';
const protocolAndDomainRE = /^(?:\w+:)?\/\/(\S+)$/;
const localhostDomainRE = /^localhost[:?\d]*(?:[^:?\d]\S*)?$/;
const nonLocalhostDomainRE = /^[^\s.]+\.\S{2,}$/;
/**
 * 获取URL中参数(decode之后的value)
 */
export function getQueryParam(key, defaultValue) {
    const searchParams = new URLSearchParams(window.location.search);
    const result = searchParams.get(key);
    if (result !== undefined && result !== null)
        return result;
    return defaultValue;
}
export function setUrlQuery(url, key, value) {
    const urlObj = new URL(url);
    const urlParams = new URLSearchParams(urlObj.search.slice(1));
    urlParams.set(key, value);
    return `${urlObj.origin}${urlObj.pathname}?${urlParams.toString()}`;
}
export function isUrl(url) {
    if (typeof url !== 'string') {
        return false;
    }
    const match = url.match(protocolAndDomainRE);
    if (!match) {
        return false;
    }
    const everythingAfterProtocol = match[1];
    if (!everythingAfterProtocol) {
        return false;
    }
    return (localhostDomainRE.test(everythingAfterProtocol) ||
        nonLocalhostDomainRE.test(everythingAfterProtocol));
}
export function deliverUrlParams(url) {
    const { url: link, query: originalQuery } = qs.parseUrl(url);
    const query = Object.assign(Object.assign({}, originalQuery), qs.parseUrl(window.location.href).query);
    if (window.VISION && window.VISION.meta) {
        const { isTest, actKey, isEditor } = window.VISION.meta;
        query.vision_fr = `${actKey}${isTest ? '_test' : ''}${isEditor ? '_editor' : ''}`;
    }
    return `${link.endsWith('/') ? link.slice(0, link.length - 1) : link}?${qs.stringify(query)}`;
}
export function open(url, newTab = false) {
    if (!isUrl(url)) {
        return;
    }
    if (newTab) {
        window.open(url);
    }
    else {
        window.open(url, '_self');
    }
}
export function openWithUrlParams(url, newTab = false) {
    if (!isUrl(url)) {
        return;
    }
    const link = deliverUrlParams(url);
    if (newTab) {
        window.open(link);
    }
    else {
        window.open(link, '_self');
    }
}
